import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginApi from '../../api/Login.api';

export default function LoginForm() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    password: '',
    email: '',
  });

  // Handle form field changes
  const handleChange = (e: any) => {
    if (isSubmitting) return;
    setShowError(false);
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await LoginApi(formData);
      navigate('/investments');
    } catch (error) {
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="d-flex flex-wrap rounded-login login-overlay">
      {/* Left Section */}
      <div className="login-left d-md-flex d-none flex-column justify-content-center align-items-start rounded-login-left text-dark">
        <h2>Our services are meant to aid you</h2>
        <p>
          lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </div>

      {/* Right Section */}
      <div className="login-right d-flex justify-content-center align-items-center rounded-login-right">
        <form className="login-form w-75" onSubmit={handleLogin}>
          <h3 className="text-dark">Welcome To Blueprint</h3>
          {/* Error Message */}
          {!showError && <div className="login-error-height mb-4"></div>}
          {showError && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-4 text-15 login-error-height"
              role="alert"
            >
              <strong>Error:</strong> Invalid email or password. Please try
              again.
            </div>
          )}
          {/* <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email" // Ensure name matches formData key
              value={formData.email} // Bind to state
              placeholder="Email"
              required
              onChange={handleChange}
            />
          </div> */}
          {/* 
<div className="mb-3">
            <span className="rounded-pill">
              <i className="fas fa-envelope"></i>
            </span>
            <input
              type="email"
              className="form-control rounded-pill w-100"
              id="email"
              name="email"
              value={formData.email}
              placeholder="Email"
              required
              onChange={handleChange}
            />
          </div> */}
          <div className="mb-3 position-relative">
            <span className="position-absolute left-0 top-50 translate-middle-y ps-3">
              <i className="fa fa-envelope"></i>
            </span>
            <input
              type="email"
              className="form-control rounded-pill w-100 ps-5" // Adding padding on left side
              id="email"
              name="email"
              value={formData.email}
              placeholder="Email"
              required
              onChange={handleChange}
            />
          </div>

          <div className="mb-3 position-relative">
            <span className="position-absolute left-0 top-50 translate-middle-y ps-3">
              <i className="fa fa-lock"></i>
            </span>
            <input
              type={passwordVisible ? 'text' : 'password'} // Toggle between text and password type
              className="form-control rounded-pill w-100 px-5"
              id="password"
              name="password"
              value={formData.password}
              placeholder="Password"
              required
              onChange={handleChange}
            />
            <span
              className="position-absolute right-0 top-50 translate-middle-y pe-3 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              <i
                className={`fa ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
              ></i>
            </span>
          </div>
          {/* <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password" // Ensure name matches formData key
              value={formData.password} // Bind to state
              placeholder="password"
              required
              onChange={handleChange}
            />
          </div> */}
          <button
            type="submit"
            className={`btn btn-lg btn-primary fw-bold w-100 rounded-pill login-button-height ${isSubmitting ? 'cursorNotAllowed' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <div
                className="spinner-border text-light fs-5"
                role="status"
              ></div>
            ) : (
              'Login'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
